<template>
  <common-dialog ref="dialog" :title="title" width="900px" :in-dialog="inDialog">
    <list ref="list" common :show-checkbox="multiple">
      <template #column>
        <slot name="column" />
        <template v-if="selectable&&!multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{row}">
              <el-button @click="onSelect(row)" type="text">选择</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "职级列表",
    },
  },
  methods: {},
};
</script>